import { type PropsWithChildren, forwardRef } from 'react'

import { Button, Tooltip } from 'antd'
import cn from 'classnames'

import type { TButtonIconProps } from '@web/shared/components/button-icon/ui/button-icon.type'

import styles from './button-icon.module.css'

export const ButtonIcon = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<TButtonIconProps>
>(
  (
    {
      materialIcon,
      children,
      tooltipProps,
      activated,
      onlyIcon,
      className,
      type,
      ...props
    },
    ref
  ) => (
    <Tooltip {...tooltipProps}>
      <Button
        {...props}
        ref={ref}
        className={cn(
          styles.buttonIcon,
          { [styles.activated]: activated, [styles.onlyIcon]: onlyIcon },
          className
        )}
        type={onlyIcon ? 'text' : type}
      >
        {materialIcon ? (
          <span className='material-symbols-sharp'>{materialIcon}</span>
        ) : (
          children
        )}
      </Button>
    </Tooltip>
  )
)
